import { environment } from '../../../environments/environment';
import { tokenData } from '../interfaces/wallet.interface';

export const tokenList: tokenData[] = [] as tokenData[];

export const nativeList: tokenData[] = [
  {
    name: 'Ethereum',
    symbol: 'ETH',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/eth_drop.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 10,
  },
  {
    name: 'Tether',
    symbol: 'USDT',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/eth_usdt_dropdown.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'Ethereum',
    symbol: 'USDC',
    category: 'ETH',
    chainId: environment.eth.chainIdInt,
    image: '/assets/images/svg-icons/usdc_eth.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'BNB',
    symbol: 'BNB',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/bnb-with-bnb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 6,
  },
  {
    name: 'Tether',
    symbol: 'USDT',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/usdt-with-bnb.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
  {
    name: 'BNB',
    symbol: 'USDC',
    category: 'BNB',
    chainId: environment.bsc.chainIdInt,
    image: '/assets/images/svg-icons/usdc_bsc.svg',
    tokenBalance: 0,
    tokenUsdVal: 0,
    desCount: 4,
  },
];
